import { useEffect } from 'react';
import { useLocation, useNavigationType } from 'react-router-dom';

/**
 * ページ遷移時にトップへスクロールするカスタムフック
 * LPなどの特定のページでのみスクロール挙動を制御したい場合に使用します。
 */
export const useScrollToTop = () => {
  const { pathname } = useLocation();
  const navigationType = useNavigationType();

  useEffect(() => {
    // "POP" (戻る/進む/リロード) 以外の遷移でのみスクロールさせる
    // これにより、リロード時のちらつき（トップに飛ばされる挙動）を防ぎつつ、
    // 新規ページ遷移時はトップから表示する
    if (navigationType !== 'POP') {
      window.scrollTo(0, 0);
    }
  }, [pathname, navigationType]);
};

// export const useScrollToTop = () => {
//   const { pathname } = useLocation();
//   useLayoutEffect(() => {
//     const originalScrollRestoration = window.history.scrollRestoration;
//     if ('scrollRestoration' in window.history) {
//       window.history.scrollRestoration = 'manual';
//     }
//     window.scrollTo(0, 0);
//     return () => {
//       if ('scrollRestoration' in window.history) {
//         window.history.scrollRestoration = originalScrollRestoration;
//       }
//     };
//   }, [pathname]);
// };